import { render, staticRenderFns } from "./AppDados.vue?vue&type=template&id=1e255b22&scoped=true&"
import script from "./AppDados.vue?vue&type=script&lang=js&"
export * from "./AppDados.vue?vue&type=script&lang=js&"
import style0 from "./AppDados.vue?vue&type=style&index=0&id=1e255b22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e255b22",
  null
  
)

export default component.exports